<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <form class="ui form" [formGroup]="profileForm">
      <div
        class="field"
        [ngClass]="displayFieldCss('profileName')"
        appMargin
        marginB="15px"
      >
        <label class="required">Profile Name</label>
        <input type="text" formControlName="profileName" />

        <app-field-error-display
          [displayError]="isFieldValid('profileName')"
          errorMsg="Please provide detail"
        >
        </app-field-error-display>
      </div>
      <div
        class="field"
        [ngClass]="displayFieldCss('requests')"
        appMargin
        marginB="15px"
      >
        <label class="required">Requests</label>
        <input type="text" formControlName="requests" />

        <app-field-error-display
          [displayError]="isFieldValid('requests')"
          errorMsg="Please provide detail"
        >
        </app-field-error-display>
      </div>
      <div
        class="field"
        [ngClass]="displayFieldCss('interval')"
        appMargin
        marginB="15px"
      >
        <label class="required">Time Interval<small>(Seconds)</small></label>
        <input type="text" formControlName="interval" />

        <app-field-error-display
          [displayError]="isFieldValid('interval')"
          errorMsg="Please provide detail"
        >
        </app-field-error-display>
      </div>
      <div
        class="field"
        [ngClass]="displayFieldCss('response')"
        appMargin
        marginB="15px"
      >
        <label class="required">Response</label>
        <input style="height: 100px" type="text" formControlName="response" />

        <app-field-error-display
          [displayError]="isFieldValid('response')"
          errorMsg="Please provide detail"
        >
        </app-field-error-display>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: transparent; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    (click)="update()"
    [disabled]="pending || !profileForm.valid"
    class="ui primary button"
  >
    Save
  </button>
</div>
